module.exports = __webpack_public_path__ + "img/logo.c79a10b9.png";